import React from 'react';
import { FormattedMessage } from 'react-intl';

const TYOMARKKINATORI_PORTAL_URL = 'https://tyomarkkinatori.fi';

/** Required Työmarkkinatori ATV attribution; shown when `isTyomarkkinatori` is true on the job. */
export function TyomarkkinatoriDataSourceAttribution() {
  return (
    <p
      className="text-center text-xs text-[#7A6E5F] dark:text-[#B8A48C] mt-4 border-t border-[#DDD5C8]/60 dark:border-[#4A3520]/60 pt-4 px-1"
      data-source="tyomarkkinatori-atv"
    >
      <FormattedMessage
        id="jobDetailPage.tyomarkkinatori.dataSourceAttribution"
        defaultMessage="Source: <link>Job Market Finland customer information system</link>"
        description="Legal attribution for Työmarkkinatori customer information system (ATV) data, with link to the official portal"
        values={{
          link: (chunks) => (
            <a
              href={TYOMARKKINATORI_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#3B5E45] dark:text-[#98CFA8] underline underline-offset-2 hover:opacity-90"
            >
              {chunks}
            </a>
          ),
        }}
      />
    </p>
  );
}
